@if (heading) {
  <div class="flex start-flex flex-row items-center justify-start pl-[0.8rem] font-1 bold600">{{heading}}</div>
}
<div class="flex flex-col items-center content-center justify-center {{additionalStyle}}
  {{circle ? 'circle' : 'chart'}}">
  <span class="font-1">{{description}}</span>
</div>
